import type * as React from 'react';
import { get } from '@Domain/Api';
import type { SubjectPayload } from '@Application/Subjects/Actions/subjectFetched';
import subjectsFetched, { type SubjectsFetchedAction } from '@Application/Subjects/Actions/subjectsFetched';
import subjectsFetchFailed, {
	type SubjectsFetchFailedAction,
} from '@Application/Subjects/Actions/subjectsFetchFailed';
import type FetchSubjects from '@Application/Subjects/Queries/FetchSubjects';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../parameters';

type Actions = SubjectsFetchedAction | SubjectsFetchFailedAction;

type SubjectsResponse = { totalRecords: number; results: SubjectPayload[] };

export default (query: FetchSubjects) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			// Server-side pagination: `get`, never `getPaginated`, which would walk every page.
			const response = await get<SubjectsResponse>(
				`${parameters.api.host}/api/accounts/${query.accountId}/subjects?${query.toQueryString()}`,
			);

			const action = subjectsFetched({
				typeId: query.typeId,
				search: query.search,
				page: query.page,
				rows: query.rows,
				totalRecords: response.totalRecords,
				results: response.results,
				fieldFilters: [...query.fieldFilters],
				fieldSort: query.fieldSort,
				includeArchived: query.includeArchived,
			});
			dispatch(action);
			return action;
		} catch (error) {
			const action = subjectsFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
